// Utility to remove pricing details
export function removePricingDetailsUtil({
    setFilteredProduct,
    deletePricingDetails,
    filteredProduct,
    setPricingNotes,
    dispatch,
    setPriceOverrideReason,
    SET_ITEMS_DURING_PRICING
}) {
    setFilteredProduct(deletePricingDetails(filteredProduct));
    setPricingNotes('');
    dispatch({
        type: 'SET_LOCAL_PRICE_COMMENTS',
        payload: '',
    });
    setPriceOverrideReason('');
    dispatch({
        type: 'SET_LOCAL_PRICE_OVERRIDE_REASON',
        payload: '',
    });
    dispatch({
        type: 'SET_ITEMS_PRICING_DONE_FLAG',
        payload: false,
    });
    dispatch({
        type: SET_ITEMS_DURING_PRICING,
        payload: [],
    });
}
